var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "m15.848 15.13-4.13-4.065a6.53 6.53 0 0 0 1.746-4.44C13.464 2.965 10.45 0 6.732 0S0 2.966 0 6.625s3.014 6.624 6.732 6.624a6.77 6.77 0 0 0 4.237-1.48l4.147 4.082c.202.199.53.199.732 0a.504.504 0 0 0 0-.722m-9.116-2.9c-3.146 0-5.696-2.51-5.696-5.605s2.55-5.606 5.696-5.606 5.696 2.51 5.696 5.606-2.55 5.605-5.696 5.605"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "search_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  })))));
};
export default SvgSearch;